// extracted by mini-css-extract-plugin
export var anchor = "Apoiadores-module--anchor--huTsn";
export var apoiador = "Apoiadores-module--apoiador--eGclj";
export var apoiadorImage = "Apoiadores-module--apoiador-image--4yW9b";
export var apoiadores = "Apoiadores-module--apoiadores--MPUog";
export var container = "Apoiadores-module--container--rZz5g";
export var organizacao = "Apoiadores-module--organizacao--VGXba";
export var wrap = "Apoiadores-module--wrap--fNLiY";